import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isPartner", "fullScreen", "renderSearch", "onTabClick", "onCatalogOptionClick"];
import { useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Box } from 'foundations-components/transitional/components/Box';
import { ACMobileHubSpotLogo } from '../ACHubSpotLogo';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Button } from 'foundations-components/transitional/components/Button';
import { ACSearchInput } from '../ACSearchInput/ACSearchInput';
import { List } from 'foundations-components/transitional/components/List';
import { useTabsConfig } from './hooks/useTabsConfig';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { FullScreenPanel } from '../FullScreenPanel';
import { ACCatalogFilterButton } from '../ACCatalog/ACCatalogFilterButton';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MobilePage = _ref => {
  let {
      children,
      isPartner,
      fullScreen,
      renderSearch,
      onTabClick,
      onCatalogOptionClick
    } = _ref,
    searchInputHandlerProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const tabs = useTabsConfig({
    isPartner
  });
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);
  const toggleNavigation = () => {
    setIsNavigationOpen(prev => !prev);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    backgroundColor: "fill-surface-default",
    flexDirection: "column",
    minBlockSize: "100vh",
    children: [/*#__PURE__*/_jsxs(Flex, {
      backgroundColor: "fill-surface-default",
      borderBlockEndColor: "border-core-default",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      flexDirection: "column",
      gap: "400",
      insetBlockStart: "0",
      padding: "400",
      position: "sticky",
      zIndex: 4,
      children: [/*#__PURE__*/_jsx(Box, {
        alignSelf: "start",
        children: /*#__PURE__*/_jsx(Button, {
          "data-test-id": "mobile-navigation-button",
          use: "unstyled",
          responsive: false,
          onClick: toggleNavigation,
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            inlineSize: "100%",
            children: [/*#__PURE__*/_jsx(ACMobileHubSpotLogo, {}), /*#__PURE__*/_jsx(IconHolder, {
              icon: DownIcon
            })]
          })
        })
      }), renderSearch && /*#__PURE__*/_jsxs(Flex, {
        gap: "400",
        children: [/*#__PURE__*/_jsx(Box, {
          flexGrow: 1,
          children: /*#__PURE__*/_jsx(ACSearchInput, Object.assign({}, searchInputHandlerProps))
        }), /*#__PURE__*/_jsx(ACCatalogFilterButton, {
          onCatalogOptionClick: onCatalogOptionClick
        })]
      })]
    }), /*#__PURE__*/_jsx(Box, {
      backgroundColor: "fill-surface-recessed",
      flexGrow: 1,
      children: /*#__PURE__*/_jsx(View, {
        blockSize: "100%",
        padding: fullScreen ? undefined : '400',
        children: children
      })
    }), /*#__PURE__*/_jsx(FullScreenPanel, {
      "data-test-id": "mobile-dropdown-menu",
      isOpen: isNavigationOpen,
      onRemoveButtonClick: toggleNavigation,
      children: /*#__PURE__*/_jsx(List, {
        childStyles: {
          marginBlockStart: '400'
        },
        firstChildStyles: {
          marginBlockStart: '0'
        },
        wrapChildren: true,
        children: tabs.map(tab => /*#__PURE__*/_jsx(RouterLink, {
          "data-test-id": `mobile-dropdown-item-${tab.tabId}-page`,
          onClick: () => {
            toggleNavigation();
            onTabClick === null || onTabClick === void 0 || onTabClick(tab.tabId);
          },
          to: tab.to,
          use: "unstyled",
          children: /*#__PURE__*/_jsx(Button, {
            block: true,
            use: "unstyled",
            children: /*#__PURE__*/_jsx(View, {
              inlineSize: "100%",
              textAlign: "start",
              children: tab.title
            })
          })
        }, tab.tabId))
      })
    })]
  });
};